(function () {
    'use strict';

    angular.module('app').factory('WebApiService', function ($http, $q, WebAPIUrl) {
        function executeRequest(httpConfig) {
            var deferred = $q.defer();

            httpConfig.timeout = deferred.promise;
            
            $http(httpConfig)
                .success(function (result) {
                    deferred.resolve(result);
                })
                .error(function (err) {
                    deferred.reject(err);
                });

            // TODO: .success and .error are deprcated.
            /* Use then (success, fail) callbacks instead
            $http(httpConfig).then(
              function(response) {
                deferred.resolve(response.data);
              },
              function(response) {
                deferred.reject(response);
              }
            );
            */

            deferred.promise.canceller = {
                deferred: deferred,
                cancel: function (result) {
                    deferred.resolve(result);
                }
            };

            return deferred.promise;
        }

        function webApiUrl(url) {
            return WebAPIUrl + url;
        }

        return {
            clearAuthorization: function () {
                $http.defaults.headers.common['Authorization'] = null;
            },
            delete: function (url, data, config) {
                var defaultConfig = {
                    method: 'DELETE',
                    ignoreLoadingBar: true
                };

                var httpConfig = $.extend(true, defaultConfig, config, {
                    url: webApiUrl(url),
                    data: data
                });

                return executeRequest(httpConfig);
            },
            get: function (url, data, config, loader) {
                var defaultConfig = {
                    method: 'GET',
                    ignoreLoadingBar: typeof loader != 'undefined' ? loader : true
                };

                var httpConfig = $.extend(true, defaultConfig, config, {
                    url: webApiUrl(url),
                    params: data
                });
                return executeRequest(httpConfig);
            },
            postFile: function (url, file, loader, progressCallback) {
                var deferred = $q.defer();

                if (!angular.isFunction(progressCallback)) {
                    progressCallback = function(e) {};
                }

                var config = {
                    transformRequest: angular.identity,
                    ignoreLoadingBar: typeof loader !== "undefined" ? loader : true,
                    headers: {
                        'Content-Type': undefined
                    },
                    uploadEventHandlers: {
                        progress: progressCallback
                    }
                };

                var fd = new FormData();
                fd.append('file', file);

                $http
                    .post(webApiUrl(url), fd, config)
                    .success(function (data) {
                        deferred.resolve(data);
                    })
                    .error(function (err, status) {
                        deferred.reject(err, status);
                    });

                return deferred.promise;
            },
            postForm: function (url, data, config) {
                var defaultConfig = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-urlencoded'
                    }
                };

                if (data) {
                    defaultConfig.ignoreLoadingBar = data.grant_type === 'password' ? false : true;
                }

                var httpConfig = $.extend(true, defaultConfig, config, {
                    url: webApiUrl(url),
                    data: data
                });

                return executeRequest(httpConfig);
            },
            postJson: function (url, data, config, loader) {
                var pat = /“|”/g; //replace “” quotes in the data to SAP compatible quote "

                angular.forEach(data, function (k, v) {
                    if (pat.test(k)) {
                        data[v] = k.replace(pat, '"');
                    }
                });

                var defaultConfig = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    ignoreLoadingBar: typeof loader !== 'undefined' ? loader : true
                };

                var httpConfig = $.extend(true, defaultConfig, config, {
                    url: webApiUrl(url),
                    data: JSON.stringify(data)
                });

                return executeRequest(httpConfig);
            },
            putJson: function (url, data, config) {
                var defaultConfig = {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    ignoreLoadingBar: true
                };

                var httpConfig = $.extend(true, defaultConfig, config, {
                    url: webApiUrl(url),
                    data: JSON.stringify(data)
                });

                return executeRequest(httpConfig);
            },
            setAuthorization: function (accessToken) {
                $http.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;
            },
            noop: function () {
                var deferred = $q.defer();
                return deferred.promise;
            }
        };
    });
})();
